import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { 
  ChatMessageDto, 
  CreateChatMessageDto, 
  ChatMessageResponse
} from "./ai-chat.dto";

const services = {
  // Kullanıcının tüm mesajlarını getir
  GetUserMessages(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<ChatMessageDto[]>("ai-chat/messages/", config);
  },

  // Yeni mesaj kaydet
  SaveChatMessage(dto: CreateChatMessageDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<ChatMessageResponse>("ai-chat/save-message/", dto, config);
  }
};

export default services; 